// Parqueo Amigo - Sistema de gestión de tickets y parqueo
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import './App.css';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import RegisterVehicle from './pages/RegisterVehicle';
import VendorsList from './pages/VendorsList';
import VendorsListPlus from './pages/VendorsListPlus';
import RecargasSD from './pages/RecargasSD';
import QuejasCiudadanas from './pages/QuejasCiudadanas';
import RechargeHistory from './pages/RechargeHistory';
import VendorDetails from './pages/VendorDetails';
import AddCA from './pages/AddCA';
import EditCA from './pages/EditCA';
import AuditLogsViewer from './pages/AuditLogsViewer';
import UserManagement from './pages/UserManagement';
import TicketSearch from './pages/TicketSearch'; // Import the TicketSearch component
import Reports from './pages/Reports'; // Import the Reports component
import TicketReports from './pages/TicketReports'; // Import the TicketReports component
import CAList from './pages/CAList'; // Import the new CAList component
import CAReports from './pages/CAReports'; // Import the new CAReports component
import TicketsDisponibles from './pages/TicketsDisponibles'; // Import the new TicketsDisponibles component
import TicketsConsorcio from './pages/TicketsConsorcio'; // Import TicketsConsorcio (copia de TicketsDisponibles)
import FacturasRecargas from './pages/FacturasRecargas'; // Import the new FacturasRecargas component
import AdminMonitoreo from './pages/AdminMonitoreo'; // Import the new AdminMonitoreo component
import PrivacyPolicy from './pages/PrivacyPolicy'; // Import the new PrivacyPolicy component
import Zonificacion from './pages/Zonificacion'; // Import the new Zonificacion component
import TokenValidationSD from './pages/TokenValidationSD'; // Import the new TokenValidationSD component
import Reporte from './pages/Reporte';
import PrivateRoute from './components/PrivateRoute';
import PageTransition from './components/PageTransition';

// Wrapper component to handle transitions
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <PageTransition key={location.pathname}>
      <Routes location={location}>
        <Route path="/login" element={<Login />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/reporte" element={<Reporte />} />
        <Route path="/dashboard" element={
          <PrivateRoute requiredRoles={["Admin", "Recaudador", "Auditor", "Financiero"]}>
            <Dashboard />
          </PrivateRoute>
        } />
        <Route path="/register" element={<RegisterVehicle />} />
        <Route path="/vehicles" element={
          <PrivateRoute requiredRoles={["Admin", "Recaudador"]}>
            <Dashboard />
          </PrivateRoute>
        } />
        <Route path="/vendors" element={
          <PrivateRoute requiredRoles={["Admin", "Supervisor", "Recaudador"]}>
            <VendorsList />
          </PrivateRoute>
        } />
        <Route path="/vendors/:id" element={
          <PrivateRoute requiredRoles={["Admin", "Supervisor", "Recaudador"]}>
            <VendorDetails />
          </PrivateRoute>
        } />
        <Route path="/recargas-sd" element={
          <PrivateRoute requiredRoles={['Admin', 'Supervisor']}>
            <RecargasSD />
          </PrivateRoute>
        } />
        <Route path="/recargas-plus" element={
          process.env.NODE_ENV === 'development' ? (
            <PrivateRoute requiredRole="Admin">
              <VendorsListPlus />
            </PrivateRoute>
          ) : (
            <Navigate to="/dashboard" replace />
          )
        } />
        <Route path="/recharges" element={
          <PrivateRoute requiredRoles={["Admin", "Supervisor", "Recaudador"]}>
            <RechargeHistory />
          </PrivateRoute>
        } />
        <Route path="/reports" element={
          <PrivateRoute requiredRoles={["Admin", "Recaudador", "Financiero"]}>
            <Reports />
          </PrivateRoute>
        } />
        <Route path="/settings" element={<Dashboard />} />
        {/* New route for ticket search */}
        <Route path="/ticket-search" element={
          <PrivateRoute requiredRoles={["Admin", "Supervisor", "Recaudador", "Auditor", "Monitoreo", "Financiero"]}>
            <TicketSearch />
          </PrivateRoute>
        } />
        {/* Ruta duplicada para Venta CA - solo Admin y Supervisor */}
        <Route path="/venta-ca" element={
          <PrivateRoute requiredRoles={["Admin", "Supervisor"]}>
            <TicketSearch />
          </PrivateRoute>
        } />
        {/* New route for ticket reports - Admin, Recaudador and Auditor */}
        <Route path="/ticket-reports" element={
          <PrivateRoute requiredRoles={["Admin", "Recaudador"]}>
            <TicketReports />
          </PrivateRoute>
        } />
        {/* New route for CA list - Admin, Auditor and CA */}
        <Route path="/ca-list" element={
          <PrivateRoute requiredRoles={["Admin", "Recaudador", "CA"]}>
            <CAList />
          </PrivateRoute>
        } />
        <Route path="/" element={<Login />} />
        <Route path="*" element={<NotFound />} />
        {/* Route for adding CA - Admin and Recaudador */}
        <Route path="/add-ca" element={
          <PrivateRoute requiredRoles={["Admin", "Recaudador"]}>
            <AddCA />
          </PrivateRoute>
        } />
        {/* Route for editing CA - Admin and Recaudador */}
        <Route path="/edit-ca/:caId" element={
          <PrivateRoute requiredRoles={["Admin", "Recaudador"]}>
            <EditCA />
          </PrivateRoute>
        } />
        {/* Route for Audit Logs - Admin and Auditor */}
        <Route path="/audit-logs" element={
          <PrivateRoute requiredRoles={["Admin"]}>
            <AuditLogsViewer />
          </PrivateRoute>
        } />
        <Route path="/user-management" element={
          <PrivateRoute requiredRole="Admin">
            <UserManagement />
          </PrivateRoute>
        } />
        {/* New route for Admin Monitoreo - Admin only */}
        <Route path="/admin-monitoreo" element={
          <PrivateRoute requiredRole="Admin">
            <AdminMonitoreo />
          </PrivateRoute>
        } />
        {/* New route for Tickets Disponibles - Admin and Auditor */}
        <Route path="/tickets-disponibles" element={
          <PrivateRoute requiredRoles={["Admin", "Auditor", "Financiero"]}>
            <TicketsDisponibles />
          </PrivateRoute>
        } />
        {/* New route for Tickets Consorcio - Solo Admin */}
        <Route path="/tickets-consorcio" element={
          <PrivateRoute requiredRole="Admin">
            <TicketsConsorcio />
          </PrivateRoute>
        } />
        {/* New route for CA reports - Admin, Supervisor and Recaudador */}
        <Route path="/ca-reports" element={
          <PrivateRoute requiredRoles={["Admin", "Supervisor", "Recaudador"]}>
            <CAReports />
          </PrivateRoute>
        } />
        {/* New route for Facturas Recargas - Solo desarrollo (Admin, Recaudador, Auditor) */}
        <Route path="/facturas-recargas" element={
          process.env.NODE_ENV === 'development' ? (
            <PrivateRoute requiredRoles={["Admin", "Recaudador"]}>
              <FacturasRecargas />
            </PrivateRoute>
          ) : (
            <Navigate to="/dashboard" replace />
          )
        } />
        {/* New route for Zonificación - Admin, Recaudador, Auditor */}
        <Route path="/zonificacion" element={
          <PrivateRoute requiredRoles={["Admin", "Recaudador", "Auditor", "Monitoreo", "Financiero"]}>
            <Zonificacion />
          </PrivateRoute>
        } />
        {/* New route for Token Validation SD - Admin, Auditor */}
        <Route path="/token-validation" element={
          <PrivateRoute requiredRoles={["Admin"]}>
            <TokenValidationSD />
          </PrivateRoute>
        } />
        <Route path="/quejas-ciudadanas" element={
          <PrivateRoute requiredRole="Admin">
            <QuejasCiudadanas />
          </PrivateRoute>
        } />
      </Routes>
    </PageTransition>
  );
};

function App() {
  return (
    <Router>
      <AnimatedRoutes />
    </Router>
  );
}

export default App;
